import DefaultUpdateTerms from './components/DefaultUpdateTerms';
import generateRender from 'shared/utils/generateRender';

const UpdateTerms = generateRender({
  default: DefaultUpdateTerms,
});

export default UpdateTerms;
